import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TechnicianService } from '../../../../services/technician.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-linked-fittings',
  templateUrl: './linked-fittings.component.html',
  styleUrls: ['./linked-fittings.component.scss']
})
export class LinkedFittingsComponent implements OnInit {

  @Input() user;
  @Input() technicianID;
  @Input() messageService: MessageService;
  public items : any = [];
  public loading = false;
  public saving = false;
  public allSelected : boolean = false;

  constructor(
    private technicianService : TechnicianService,
    private translate : TranslateService
  ) { }

  ngOnInit() {
    this.loading = true;
    this.technicianService.getTechniciansLinkedFittings(this.technicianID).subscribe(result=>{
      this.items = result;
      this.loading = false;
      if(this.items.filter(x=>{return x.linked === true}).length === this.items.length){
        this.allSelected = true;
      }
    },err=>{
      this.loading = false;
    });
  }

  updateItems(){
    this.saving = true;
    this.technicianService.updateTechniciansLinkedFittings(this.technicianID, this.items).subscribe(res=>{
      this.saving = false;
      this.messageService.add({
        life: 5000,
        detail: this.translate.instant('bikeshop.users.linked_fittings_saved')
      });
    },err=>{
      this.saving = false;
    })
  }

  checkMainSelectAll(){
    if(this.items.filter(x=>{return x.linked === true}).length === this.items.length){
      this.allSelected = true;
    }else{
      this.allSelected = false;
    }
  }

  updateLinks(event){
    console.log(event);
    if(event){
      this.items.forEach(item => {
        item.linked = true;
      });
    }else{
      this.items.forEach(item => {
        item.linked = false;
      });
    }
  }


}
